import { VSBuffer } from 'monaco-editor/esm/vs/base/common/buffer.js';
class DataTransferCache {
    constructor() {
        this.requestIdPool = 0;
        this.dataTransfers = ( new Map());
    }
    add(dataTransfer) {
        const requestId = this.requestIdPool++;
        this.dataTransfers.set(requestId, [...( dataTransfer.values())]);
        return {
            id: requestId,
            dispose: () => {
                this.dataTransfers.delete(requestId);
            }
        };
    }
    async resolveFileData(requestId, dataItemId) {
        const entry = this.dataTransfers.get(requestId);
        if (!entry) {
            throw new Error('No data transfer found');
        }
        const item = entry.find(x => x.id === dataItemId);
        if (!item) {
            throw new Error('No item found in data transfer');
        }
        const file = item.asFile();
        if (!file) {
            throw new Error('Found data transfer item is not a file');
        }
        return VSBuffer.wrap(await file.data());
    }
    dispose() {
        this.dataTransfers.clear();
    }
}
export { DataTransferCache };
